import { takeEvery, all, put, call } from "redux-saga/effects"
import { DckActionTypes } from "dck-redux"

import ProcessTypes from "../../processes/types"
import * as ItemTypes from "../../items/types"
import * as authRequest from "../authRequest"
import { browserHistory } from "react-router"
import { makeSagaQuery } from "../utils"
import {
  addUniqueValue,
  convertToObject,
  getAccessToken,
  HTTP_VERB,
  parseFetchError,
  UserRoles
} from "../../../lib/utils"
import authServerConstans from "../authServerConstans"
import apiServerApi from "../apiServerApi"

function* loadUsersSaga() {

  const userRoleNames = [],

  resp = yield makeSagaQuery(
    `${authServerConstans.host}/api/user/getAll`,
    HTTP_VERB.GET,
    null,
    ProcessTypes.USERS_LOAD,
    true,
    response => {

      let users = response.data
      if (!(users instanceof Array)) return

      users = users.filter(item => item.userRole !== UserRoles.SUPER)
      users.forEach(user => addUniqueValue(userRoleNames, user.userRole))

      return {
        type: DckActionTypes.ITEMS_SET,
        itemType: ItemTypes.User,
        data: users
      }
    }
  )

  if (resp) {
    yield put({
      type: DckActionTypes.ITEMS_SET,
      itemType: ItemTypes.UserRoleFilter,
      data: [ convertToObject(userRoleNames) ]
    })
  }
}

function* createUserSaga(action) {

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_START,
    processCode: ProcessTypes.USERS_ADD
  })

  let processResult

  try {
    yield call(authRequest.makeAuthRequest, authRequest.ADD_USER, action.data)
    processResult = { success: true, message: null }
    yield call(browserHistory.push, "/users")
  }
  catch (error) {
    processResult = { success: false, message: error }
  }

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_STOP,
    processCode: ProcessTypes.USERS_ADD,
    result: processResult
  })
}

function* deleteUserSaga(action) {

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_START,
    processCode: ProcessTypes.USERS_REMOVE
  })
  let processResult

  try {
    yield call(authRequest.makeAuthRequest, authRequest.DELETE_USER, {
      userId: action.id
    })

    yield put({
      type: DckActionTypes.ITEMS_LOAD,
      itemType: ItemTypes.User
    })

    processResult = { success: true, message: null }
  }
  catch (error) {
    processResult = { success: false, message: error }
  }

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_STOP,
    processCode: ProcessTypes.USERS_REMOVE,
    result: processResult
  })
}

function* updateUserSaga(action) {

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_START,
    processCode: ProcessTypes.USERS_UPDATE
  })
  let processResult

  try {
    const { data } = action

    yield call(
      authRequest.makeAuthRequest,
      authRequest.UPDATE_USER,
      data
    )

    // Update in API server
    yield call(apiServerApi.updateUserData, getAccessToken(), data.username)

    processResult = { success: true, message: null }
    yield call(browserHistory.push, "/users")

  }
  catch (error) {
    processResult = { success: false, message: parseFetchError(error).text }
  }

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_STOP,
    processCode: ProcessTypes.USERS_UPDATE,
    result: processResult
  })
}

function* resetUserPasswordSaga(action) {

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_START,
    processCode: ProcessTypes.RESET_USER_PASSWORD
  })
  let processResult

  try {
    yield call(authRequest.makeAuthRequest, authRequest.RESET_USER_PASSWORD, {
      userId: action.id
    })

    yield call(browserHistory.push, "/users")
    processResult = { success: true, message: null }
  }
  catch (error) {
    processResult = { success: false, message: parseFetchError(error).text }
  }

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_STOP,
    processCode: ProcessTypes.RESET_USER_PASSWORD,
    result: processResult
  })
}

function* usersSaga() {

  yield all([

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEMS_LOAD &&
        action.itemType === ItemTypes.User,
      loadUsersSaga
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_ADD &&
        action.itemType === ItemTypes.User,
      createUserSaga
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_REMOVE &&
        action.itemType === ItemTypes.User,
      deleteUserSaga
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_SAVE &&
        action.itemType === ItemTypes.User,
      updateUserSaga
    ),

    takeEvery(
      action =>
        action.type === ProcessTypes.RESET_USER_PASSWORD &&
        action.itemType === ItemTypes.User,
      resetUserPasswordSaga
    )
  ])
}

export default usersSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/items/users.js